import { Settings } from '@mui/icons-material';
import { Menu, MenuItem, Switch } from '@mui/material';
import { MenuIcon } from 'components/buttons';
import { OrderContext } from 'contexts/OrderContext';
import { VisibilityContext } from 'contexts/VisibilityContext';
import { useContext } from 'react';
import {
  DragDropContext,
  DragDropContextProps,
  Draggable,
  Droppable,
  DroppableProps,
} from 'react-beautiful-dnd';
import { useTranslation } from 'react-i18next';
import { useContextMenu } from 'kineticUtils';

import { ControlsProps } from './types';

const Controls: React.FunctionComponent<ControlsProps> = (_props) => {
  const {
    handleCloseMenu,
    handleOpenMenu,
    props: { getContentAnchorEl: _, ...menuProps },
  } = useContextMenu<HTMLButtonElement>({
    anchorOrigin: {
      horizontal: 'left',
      vertical: 'bottom',
    },
    transformOrigin: {
      horizontal: 'right',
      vertical: 'top',
    },
  });
  const { t } = useTranslation('common');
  const onSettingsClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (menuProps.open) {
      handleCloseMenu();
    } else {
      handleOpenMenu(e);
    }
  };

  const { order, updateOrder } = useContext(OrderContext);
  const { isVisible, toggle } = useContext(VisibilityContext);

  const onDragEnd: DragDropContextProps['onDragEnd'] = (result, _provided) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    updateOrder(result.draggableId, result.destination.index);
  };

  const renderItems: DroppableProps['children'] = (dropProvided, _snapshot) => {
    return (
      <div {...dropProvided.droppableProps} ref={dropProvided.innerRef}>
        {order.map((name, index) => (
          <Draggable key={name} draggableId={name} index={index}>
            {(dragProvided) => (
              <MenuItem
                ref={dragProvided.innerRef}
                {...dragProvided.draggableProps}
                {...dragProvided.dragHandleProps}
                style={{
                  ...dragProvided.draggableProps.style,
                  display: 'flex',
                }}
                key={name}
              >
                {name}
                <span style={{ marginLeft: 'auto' }}>
                  <Switch
                    name={name}
                    checked={isVisible(name)}
                    onChange={() => toggle(name, true)}
                  />
                </span>
              </MenuItem>
            )}
          </Draggable>
        ))}
        {dropProvided.placeholder}
      </div>
    );
  };

  const renderControls = () => {
    return (
      <>
        <MenuIcon onClick={onSettingsClick} tooltip={t('settings')}>
          <Settings />
        </MenuIcon>
        <Menu {...menuProps}>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId='entityDrawerItems'>{renderItems}</Droppable>
          </DragDropContext>
        </Menu>
      </>
    );
  };

  return renderControls();
};

export default Controls;
